import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';

import {TransportType} from '@shared';

import {
    EmployeeService,
    NavigationService,
    ProblemInstanceService,
} from 'planner-shared';

import {ToggleComponent} from '../../../../_shared/toggle/toggle.component';
import {take} from "rxjs/operators";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-ride-sharing-bar',
    templateUrl: './ride-sharing-bar.component.html',
    styleUrls: ['./ride-sharing-bar.component.scss'],
    standalone: false
})
export class RideSharingBarComponent implements OnInit, OnDestroy {
    private readonly problemInstanceService = inject(ProblemInstanceService);
    private readonly employeeService = inject(EmployeeService);
    private readonly navigationService = inject(NavigationService);

    public toggleValue: boolean;
    public toggleDisabled = true;
    public tooltipText = 'RIDE_SHARING_DISABLED_TOOLTIP';
    public rideSharingPassengersCount = 0;
    public rideSharingDriversCount = 0;
    @ViewChild(ToggleComponent) public toggleComponent: ToggleComponent;

    private navigationSaveClickSubscription: Subscription;

    ngOnInit(): void {
        this.loadEmployees(true);
        this.navigationSaveClickSubscription = this.navigationService
            .saveButtonClick()
            .subscribe(() =>
                this.navigationService.getCurrentPage().pipe(
                    take(1)
                ).subscribe(currentPage => {
                    if (currentPage === 0) {
                        this.employeeService.employeeUpdateConfirm$
                            .pipe(
                                take(1)
                            ).subscribe(() => this.loadEmployees(false));
                    } else if (currentPage === 1) {
                        this.employeeService.updateEditedEmployeesInfo()
                            .pipe(
                                take(1)
                            ).subscribe(() => this.loadEmployees(false));
                        this.navigationService.showSaveAndResetButtons(false);
                    }
                })
            );
        this.navigationService
            .resetButtonClick()
            .subscribe(() => this.loadEmployees(true));

    }

    ngOnDestroy() {
        if (this.navigationSaveClickSubscription) {
            this.navigationSaveClickSubscription.unsubscribe();
        }
    }

    public toggleChange(value: boolean | null, byInit: boolean): void {
        if (value === null) {
            value = this.toggleComponent.value;
            this.navigationService.showSaveAndResetButtons(true);
        } else {
            this.toggleComponent.value = value;
        }
        this.toggleValue = value;

        if (value) {
            this.tooltipText = 'RIDE_SHARING_ENABLED_TOOLTIP';
        } else {
            this.employeeService.getEmployees()
                .subscribe(employees => employees
                    .forEach(employee => {
                        employee.rideSharing = false;
                        employee.editing = !byInit;
                    })
                );
            this.toggleDisabled = true;
            this.tooltipText = 'RIDE_SHARING_DISABLED_TOOLTIP';
        }
    }

    public loadEmployees(byInit: boolean): void {
        this.problemInstanceService.requestProblemInstance()
            .subscribe(problemInstanceResult => {
                this.rideSharingPassengersCount = problemInstanceResult.problemInstance.employeeWorkShifts
                    .filter(employee => employee.isActive && employee.rideSharing && employee.transport === TransportType.Walk).length;
                this.rideSharingDriversCount = problemInstanceResult.problemInstance.employeeWorkShifts
                    .filter(employee => employee.isActive && employee.rideSharing && employee.transport === TransportType.Drive).length;
                if (problemInstanceResult.problemInstance.officeInfo.useRideSharingForOptimization
                    && problemInstanceResult.problemInstance.officeInfo.rideSharingEnabledOnClientSide
                ) {
                    this.toggleChange(true, byInit);
                    if (this.toggleValue) {
                        this.toggleDisabled = false;
                    }
                } else {
                    this.toggleChange(false, byInit);
                }
            });
    }
}
